import { Component, Inject, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { Observable } from "rxjs";
import { GlobalVariable } from "../../app.component";
import { DataService, Response } from "../../dataService/data.service";
import { CommonService } from "../../services/common.service";

@Component({
  selector: "app-leaderboard-reviews",
  templateUrl: "./leaderboard-reviews.component.html",
  styleUrls: ["./leaderboard-reviews.component.scss"],
})
export class LeaderboardReviewsComponent implements OnInit {
  @Input() leaderboardAvailable: boolean;
  public loading = false;

  private BASE_URL = GlobalVariable;
  outletId: string;
  latestReviews: Observable<any>;
  leaderboardList: any = [];
  reviewClickStep: any;
  userRole: any;

  constructor(
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private httpService: DataService,
    private router: Router,
    private commonservice: CommonService
  ) {}

  ngOnInit() {
    this.loading = true;
    let res: Response;
    this.outletId = this.storage.get("outlet_id");
    this.getUserRole();
  }

  getUserRole() {
    this.httpService
      .getRequest({ customApiUrl: this.BASE_URL.USER_PROFILE(this.outletId) })
      .subscribe(
        (res: any) => {
          if (res.code == 200) {
            this.userRole = res.data.role;
            console.log(this.userRole);
          }
        },
        (err) => {},
        () => {
          this.getLeaderboardDetails();
        }
      );
  }

  getLeaderboardDetails() {
    this.httpService
      .getRequest({
        customApiUrl: this.BASE_URL.GET_LEADERBOARD_DATA(this.outletId),
        filter_by: "ALL_TIME",
        size: "3",
      })
      .subscribe((res: any) => {
        console.log(res);
        if (res.code === 200) {
          this.leaderboardList = res.data.leaderboard_detail;
          this.reviewClickStep = res.data.review_click_steps;
        }
        this.loading = false;
      });
  }

  redirect() {
    this.router.navigate(["/team/leaderboard"], {
      queryParams: {
        redirect_to: "ALL_TIME",
      },
    });
  }
}
